var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecommendation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 2.35742C16.6667 2.35742 11.1074 7.91673 11.1074 14.75C11.1074 21.5833 16.6667 27.1426 23.5 27.1426C30.3333 27.1426 35.8926 21.5833 35.8926 14.75C35.8926 7.91673 30.3333 2.35742 23.5 2.35742Z",
    fill: "url(#paint0_linear_2531_1267)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9188 35.2386C35.5259 31.7937 31.0282 29.8965 26.2539 29.8965H20.7461C15.9719 29.8965 11.4741 31.7937 8.08125 35.2386C4.70505 38.6667 2.8457 43.1917 2.8457 47.9805C2.8457 48.7409 3.46221 49.3574 4.22266 49.3574H42.7773C43.5378 49.3574 44.1543 48.7409 44.1543 47.9805C44.1543 43.1917 42.295 38.6667 38.9188 35.2386Z",
    fill: "url(#paint1_linear_2531_1267)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7624 40.6309C50.7624 46.2264 46.2264 50.7624 40.6309 50.7624C35.0353 50.7624 30.4993 46.2264 30.4993 40.6309C30.4993 35.0353 35.0353 30.4993 40.6309 30.4993C46.2264 30.4993 50.7624 35.0353 50.7624 40.6309Z",
    fill: "url(#paint2_linear_2531_1267)",
    stroke: "#FBF5E8",
    strokeWidth: 1.73684,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40 37V41.4762L42.7976 44.2738",
    stroke: "#FBF5E8",
    strokeWidth: 1.67857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2531_1267",
    x1: 11.1074,
    y1: 14.7505,
    x2: 35.8926,
    y2: 14.7505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED6C14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF9045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB54A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2531_1267",
    x1: 2.8457,
    y1: 39.6273,
    x2: 44.1543,
    y2: 39.6273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED6C14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF9045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB54A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2531_1267",
    x1: 29.6309,
    y1: 40.6313,
    x2: 51.6309,
    y2: 40.6313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED6C14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF9045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB54A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecommendation);
export default __webpack_public_path__ + "static/media/recommendation.277b9e8c1c5551375fb31a32b0b8d126.svg";
export { ForwardRef as ReactComponent };